import {birthDate,gender} from 'chinese-idcard-checker';
import moment from 'moment';

export const changecolor = (record)=>{
	let {confirm,type,isMoneyGive,yiIdCard } = record
	if(type == 4){ //扫码登记
		let sex = gender(yiIdCard),age = moment().diff(moment(birthDate(yiIdCard)),"years");
		if(sex=="男"&&age>=60||sex=="女"&&age>=50){
			return "bianhong"
		} 
	}
	if(type == 3 ||type == 2||type==8){ // 工资预支单 || 个人结算单
		if(isMoneyGive == 1){
			return 'bianhuang'
		}	
	}
	if(confirm == 1){
		return "bianlv"
	} 
	// 工资预支单和进场登记已确认不变绿色
	return ""
}